import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaCalculoCalcularResultadosComponent {
  constructor () {
    this.data = []
  }

  $onChanges (changes) {
    if (changes.data) {
      this.remunerados = this.data.filter((item) => !item.config.cobro_carga_social)
      this.noremunerados = this.data.filter((item) => item.config.cobro_carga_social)
    }
  }
}

module.component('nominasNominaCalculoCalcularResultados', {
  controller: NominasNominaCalculoCalcularResultadosComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/calculo/calcular/resultados/component.js